import axios from "axios";
import Cookie from 'js-cookie';

const axiosInstance = axios.create({
    baseURL: 'https://api.warshatna.com/api/',
    // baseURL: 'https://www.bytespilot.net/ca-server/api/',
    // baseURL: 'https://bytespilot.net/ca-server',
    // baseURL: 'https://warshatna.herokuapp.com/api/',
    responseType: "json"
  });

axiosInstance.interceptors.request.use(config => {
  const token = Cookie.get("TOKEN");
  const authorizedConfig = {...config}
  if(token){
    authorizedConfig.headers.Authorization = `Bearer ${token}`
  }
  return config
})

axiosInstance.interceptors.response.use(response => response);
  
export default axiosInstance;